export default "__VITE_ASSET__073fe420__"